module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-kids-b47202739ca2bba65a3cbcb2ced88dc7.webp";